import { z } from 'zod';
import { UserSummary } from './profile.js';
export const FamilyAwardTags = z.enum([
    'Children & Family',
    'Community Service',
    'Faith',
    'Mentoring',
]);
export const FamilyAwardVisibility = z.enum(['judges', 'family_community', 'public']);
export const FamilyAwardStatus = z.enum(['draft', 'awaiting_spouse', 'submitted', 'withdrawn']);
export const FamilyAwardSeasonFields = z.object({
    title: z.string().trim().min(3).max(120),
    opensAt: z.iso.datetime(),
    closesAt: z.iso.datetime(),
    enabled: z.boolean(),
});
export const CreateFamilyAwardSeasonInput = FamilyAwardSeasonFields.refine((v) => Date.parse(v.opensAt) < Date.parse(v.closesAt), 'Closing time must be after opening time');
export const UpdateFamilyAwardSeasonInput = FamilyAwardSeasonFields.extend({
    expectedVersion: z.number().int().nonnegative(),
}).refine((v) => Date.parse(v.opensAt) < Date.parse(v.closesAt), 'Closing time must be after opening time');
export const FamilyAwardSeasonView = FamilyAwardSeasonFields.extend({
    id: z.string(),
    version: z.number().int().nonnegative(),
    acceptingEntries: z.boolean(),
});
export const SaveFamilyAwardEntryInput = z
    .object({
    seasonId: z.string().min(1).max(128),
    expectedVersion: z.number().int().nonnegative().nullable(),
    step: z.number().int().min(1).max(5),
    story: z.string().trim().max(500),
    tags: z
        .array(FamilyAwardTags)
        .max(4)
        .refine((v) => new Set(v).size === v.length, 'Choose each tag once'),
    visibility: FamilyAwardVisibility,
    mode: z.enum(['draft', 'submit']),
    consent: z.boolean(),
})
    .superRefine((v, ctx) => {
    if (v.mode !== 'submit')
        return;
    if (!v.story)
        ctx.addIssue({ code: 'custom', path: ['story'], message: 'Tell your journey story' });
    if (!v.tags.length)
        ctx.addIssue({ code: 'custom', path: ['tags'], message: 'Choose an impact area' });
    if (!v.consent)
        ctx.addIssue({ code: 'custom', path: ['consent'], message: 'Agree to submit this story' });
});
export const FamilyAwardVersionInput = z.object({
    expectedVersion: z.number().int().nonnegative(),
});
export const FamilyAwardEntryView = z.object({
    id: z.string(),
    version: z.number().int().nonnegative(),
    seasonId: z.string(),
    seasonTitle: z.string(),
    marriageId: z.string(),
    marriageVersion: z.number().int().nonnegative(),
    participants: z.array(UserSummary).length(2),
    status: FamilyAwardStatus,
    step: z.number().int().min(1).max(5),
    story: z.string(),
    tags: z.array(FamilyAwardTags),
    visibility: FamilyAwardVisibility,
    years: z.number().int().nonnegative(),
    tier: z.enum(['0–5', '6–9', '10', '15', '20', '25+']),
    needsMyConfirmation: z.boolean(),
    eligible: z.boolean(),
    canEdit: z.boolean(),
    submittedAt: z.iso.datetime().nullable(),
});
export function familyAwardTier(years) {
    return years >= 25
        ? '25+'
        : years >= 20
            ? '20'
            : years >= 15
                ? '15'
                : years >= 10
                    ? '10'
                    : years >= 6
                        ? '6–9'
                        : '0–5';
}
//# sourceMappingURL=family-awards.js.map